<template>
  <div v-if="showComponent">
    <vs-card>
      <div slot="header">
        <h3>Custo do Sinistro</h3>
      </div>
      <div>
        <!-- <div class="vx-row"> -->
        <!-- Tipo de Cota de Participação -->
        <!-- <div class="vx-col lg:w-1/2 w-full mb-2">
            <label class="vs-select--label">Tipo de Cota de Participação</label>
            <v-select
              class="selectStyle"
              :options="listTipoCotaParticipacao"
              name="Tipo de Cota de Participação"
              id="Tipo de Cota de Participação"
              v-model="formCustoEvento.idTipoCotaParticipacao"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div> -->

        <div class="vx-row">
          <!-- Cota de Participação -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Valor Cota de Participação</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.cotaParticipacao"
              name="Valor Cota de Participação"
              v-bind="money"
            />
          </div>

          <!-- Valor de participação mínima -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <span class="vs-input--label"> Valor de participação mínima </span>
            <p class="moneyStyle">
              {{ functions.formataReal(valorParticipacaoMinimo) }}
            </p>
          </div>

          <!-- Valor Fipe (Cadastro do Veículo) -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <span class="vs-input--label">
              Valor Fipe (Cadastro do Veículo)
            </span>
            <p class="moneyStyle">
              {{ functions.formataReal(valorFipe) }}
            </p>
          </div>

          <div
            class="vx-col lg:w-1/4 w-full mb-2 flex justify-center items-center"
          >
            <vs-button @click="calculcarValorCotaParticipacao()">
              Calcular Valor Cota de Participação
            </vs-button>
          </div>

          <!-- Valor Fipe (Cadastro do Veículo) -->
          <!-- <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label"
              >Valor Fipe (Cadastro do Veículo)</label
            >
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.valorFipeCadastroVeiculo"
              name="Valor Fipe (Cadastro do Veículo)"
              v-bind="money"
            />
          </div> -->

          <!-- Valor Fipe (Cadastro do Reparo) -->
          <!-- <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label"
              >Valor Fipe (Cadastro do Reparo)</label
            >
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.valorFipeCadastroReparo"
              name="Valor Fipe (Cadastro do Reparo)"
              v-bind="money"
            />
          </div> -->

          <!-- Valor Fipe (Dia do Evento) -->
          <!-- <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Valor Fipe (Dia do Evento)</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.valorFipeDiaEvento"
              name="Valor Fipe (Dia do Evento)"
              v-bind="money"
            />
          </div> -->
        </div>

        <div class="vx-row">
          <!-- Previsão de Valor de Reparo -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Previsão de Valor de Reparo</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.previsaoValorReparo"
              name="Previsão de Valor de Reparo"
              v-bind="money"
            />
          </div>

          <!-- Depreciação Motivo -->
          <div class="vx-col lg:w-3/4 w-full mb-2">
            <vs-input
              class="w-full"
              label="Depreciação Motivo"
              placeholder=""
              v-model="formCustoEvento.depreciacaoMotivo"
              name="Depreciação Motivo"
            />
          </div>
        </div>

        <div class="vx-row">
          <!-- Depreciação % -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Depreciação %</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.depreciacaoPorCento"
              name="Depreciação %"
              v-bind="porCento"
            />
          </div>

          <!-- Depreciação Valor -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Depreciação Valor</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.depreciacaoValor"
              name="Depreciação Valor"
              v-bind="money"
            />
          </div>

          <!-- Valor de Reparo -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Valor de Reparo</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.valorReparo"
              name="Valor de Reparo"
              v-bind="money"
            />
          </div>

          <!-- Custo de Reparo -->
          <!-- (Cálculo = Valor de reparo-participação) -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <label class="vs-input--label">Custo de Reparo</label>
            <money
              class="w-full vs-inputx vs-input--input moneyStyle"
              v-model="formCustoEvento.custoReparo"
              name="Custo de Reparo"
              v-bind="money"
            />
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
// import vSelect from 'vue-select';
import { Money } from 'v-money';
import functions from '../../../../../../../utils/functions';

export default {
  props: ['formData', 'dominios'],
  watch: {
    formData(value) {
      if (!value.custoEvento) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - CUSTO EVENTO FORM');
        return;
      }

      this.formCustoEvento = Object.assign(
        this.formCustoEvento,
        value.custoEvento,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.custoEvento = this.formCustoEvento;

      this.valorFipe = value.dadosVeiculo.valorFipe || 0;
      this.valorParticipacaoMinimo =
        value.dadosVeiculo.valorParticipacaoMinimo || 0;
      this.cotaParticipacao = value.dadosVeiculo.cotaParticipacao || 0;
    },
  },
  components: {
    // vSelect,
    Money,
  },
  data() {
    return {
      showComponent: true,
      formCustoEvento: {
        cotaParticipacao: 0,
        valorFipeCadastroVeiculo: 0,
        valorFipeCadastroReparo: 0,
        valorFipeDiaEvento: 0,
        previsaoValorReparo: 0,
        depreciacaoMotivo: null,
        depreciacaoPorCento: 0,
        depreciacaoValor: 0,
        valorReparo: 0,
        custoReparo: 0,
      },
      listTipoCotaParticipacao: [],
      valorFipe: 0,
      valorParticipacaoMinimo: 0,
      cotaParticipacao: 0,

      //Configurações de componente
      porCento: {
        decimal: '',
        thousands: '',
        prefix: '',
        suffix: '%',
        precision: 0,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$',
        suffix: '',
        precision: 2,
      },
      functions,
    };
  },
  methods: {
    calculcarValorCotaParticipacao() {
      const valorCotaParticipacao =
        this.valorFipe * (this.cotaParticipacao / 100);

      this.formCustoEvento.cotaParticipacao =
        valorCotaParticipacao < this.valorParticipacaoMinimo
          ? this.valorParticipacaoMinimo
          : valorCotaParticipacao;
    },
  },
  mounted() {
    if (!this.formData.custoEvento) {
      console.error('ERRO NO CONTRATO DO OBJETO - CUSTO EVENTO FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.custoEvento = this.formCustoEvento;

    this.listTipoCotaParticipacao = this.dominios.listTipoCotaParticipacao;
  },
};
</script>

<style scoped>
.moneyStyle {
  font-size: 1rem !important;
  padding: 0.7rem !important;
}
.selectStyle {
  font-size: 1rem !important;
}
</style>
